export const DynamicPriceLastConditionEnum = {
    0: '& Above',
    1: 'Maximum quantity',
};